import React from 'react';
import { Form, type FormControlProps } from 'react-bootstrap';
import { clsx } from '../helpers/clsx.js';

type PlainTextEditProps = { isReadOnly: boolean; onFocus: (newValue: boolean) => void } & FormControlProps;
export const PlainTextEdit = ({
  isReadOnly,
  onFocus,
  id,
  name,
  value,
  className,
  onChange,
  onBlur,
  isInvalid,
  isValid,
  ...props
}: PlainTextEditProps) => {
  return (
    <Form.Control
      type="search"
      id={id}
      name={name}
      aria-label={props['aria-label']}
      value={value}
      readOnly={isReadOnly}
      plaintext={isReadOnly}
      style={
        isReadOnly ? { cursor: 'pointer', textDecorationLine: 'underline', textDecorationStyle: 'dotted' } : undefined
      }
      className={clsx({ 'user-select-none': isReadOnly, 'form-control': isReadOnly }, className)}
      onFocus={onFocus}
      onChange={onChange}
      isInvalid={isInvalid}
      isValid={isValid}
      onBlur={onBlur}
      {...props}
    />
  );
};
